// "Muggle" preview semantics, shared by every nav / page-catalog context builder
// (nav registry, report catalog, site map, map pages) so the rail, the site map,
// the report dashboards and the map pages all agree on what the preview shows.
//
// An admin with view_as === 'non-admin' is previewing the app AS the highest-
// privilege CUSTOMER -- a customer-admin -- NOT an admin with privileges merely
// stripped. Presenting the effective role as customer-admin is what makes the
// preview match what a real customer sees. Leaving role === 'admin' reads
// STRICTER than any real customer, because the customer-admin-gated rows (the
// whole Settings section, Alert Settings, Group Messages, the Anderson Fleet
// Assistant tab, ...) check `role === 'customer-admin'` and would vanish -- so
// "preview as a non-admin" showed less than the customer it was meant to mimic.
//
// isEffectiveAdmin is always derived from the REAL role, so it stays correctly
// false in the preview (the admin-only surfaces still hide).

export function isMuggle(user, viewAs) {
  return !!user && user.role === 'admin' && viewAs === 'non-admin'
}

// the viewer to gate against: the customer-admin twin while in muggle preview,
// otherwise the real viewer. Only the role changes; tenant/features/types are
// carried through untouched.
export function effectiveUser(user, viewAs) {
  return isMuggle(user, viewAs) ? { ...user, role: 'customer-admin' } : user
}

export function computeEffectiveAdmin(user, viewAs) {
  return !!user && user.role === 'admin' && viewAs !== 'non-admin'
}
